import { tryJsonParse } from '../functions.js';

export default class ConditionalRenderElement extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        _conditionalRender(this);
    }
};

function _conditionalRender(element) {

    let qsa = element.querySelectorAll.bind(element);

    function init() {
        qsa('*[x\\:conditional]').forEach((subelm) => {
            subelm.style.display = 'none';

            let conditionalSelector = subelm.getAttribute('x:conditional');

            let conditionalElement = document.querySelector(conditionalSelector);

            if (!conditionalElement) {
                return;
            }

            conditionalElement.addEventListener('change', function() {
                toggle(subelm, conditionalElement);
            });

            toggle(subelm, conditionalElement);
        });
    }

    function toggle(targetSubelement, conditionalElement) {

        let conditionalValue = targetSubelement.getAttribute('x:value');

        let jsonValue = tryJsonParse(conditionalValue);

        if (jsonValue && Array.isArray(jsonValue) && jsonValue.includes(conditionalElement.value)) {
            targetSubelement.style.display = '';
        } 
        else if (conditionalElement.value === conditionalValue) {
            targetSubelement.style.display = '';
        } else {
            targetSubelement.style.display = 'none';
        }
    }

    init();

    return this;

};


window.customElements.define('conditional-render', ConditionalRenderElement);
